import React from 'react';
import { useBrand } from '../../contexts/BrandContext';
interface LogoProps {
  variant?: 'full' | 'wordmark' | 'mark';
  /** Shows the tagline beneath the wordmark, as in the printed identity lockup. */
  withTagline?: boolean;
  className?: string;
  markClassName?: string;
}
export function Logo({
  variant = 'full',
  withTagline = false,
  className = '',
  markClassName = ''
}: LogoProps) {
  const {
    brand
  } = useBrand();
  const isUpper = brand.wordmarkCase === 'upper';
  return <span className={`inline-flex items-center gap-2.5 ${className}`} data-id="element-27" data-mp="yy43npg24irt">
      {variant !== 'wordmark' && <Mark className={markClassName} data-id="element-28" data-mp="13x7a9eboqx1w" />}
      {variant !== 'mark' && <span className="flex flex-col" data-id="element-29" data-mp="14036my7vxdo8">
          <span className={`font-serif leading-none ${isUpper ? 'text-[0.95em] font-medium tracking-wordmark' : 'text-[1.3em] font-semibold tracking-tight'}`} data-id="element-30" data-mp="18x3bx6wwucea">
            {brand.wordmark}
          </span>
          {withTagline && <span className="mt-2 text-[0.4em] uppercase tracking-label text-current opacity-80" data-id="element-31" data-mp="1ww8o5jw70o40">
              {brand.tagline}
            </span>}
        </span>}
      <span className="sr-only" data-id="element-32" data-mp="1nw2ek93m88a4">{brand.name}</span>
    </span>;
}
export function Mark({
  className = ''
}: {
  className?: string;
}) {
  const {
    brand
  } = useBrand();
  if (brand.mark === 'leaf') {
    return <svg viewBox="0 0 32 32" aria-hidden="true" className={`h-[1.5em] w-[1.5em] shrink-0 ${className}`} fill="none" data-id="element-33" data-mp="1dzfyryq5c7ey">
        <path d="M5 27C5 15.954 13.954 7 25 7C25 18.046 16.046 27 5 27Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" data-id="element-34" data-mp="148la6npfgvqc" />
        <path d="M5 27L19 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-35" data-mp="105g9mqowr44c" />
      </svg>;
  }

  /**
   * Republic monogram, hand-redrawn from the printed identity: a geometric R with a
   * squared bowl and a long straight leg that reads as a folded ribbon. Replace this
   * path with the supplied vector artwork when it is available.
   */
  return <svg viewBox="0 0 44 48" aria-hidden="true" className={`h-[1.6em] w-[1.47em] shrink-0 ${className}`} data-id="element-36" data-mp="lm5bpuvhww4c">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H25C32.7 0 39 5.37 39 12C39 17.9 34 22.8 27.4 23.8L44 48H31.6L16.4 26H9.4V48H0V0ZM9.4 8H24.4C27.2 8 29.4 9.79 29.4 12C29.4 14.21 27.2 16 24.4 16H9.4V8Z" fill="currentColor" data-id="element-37" data-mp="bmejjzueqt7f" />
    </svg>;
}